import React from 'react';
import { Coins } from 'lucide-react';
import { useCredits } from '../contexts/CreditsContext';
import { useAuth } from '../contexts/AuthContext';

const CreditBalanceBadge = ({ className = '' }) => {
  const { user } = useAuth();
  const { credits, lowThreshold, openBuyModal, loading } = useCredits();

  if (!user) return null;

  const isLow = credits <= lowThreshold;
  return (
    <button
      onClick={() => openBuyModal()}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1.5 border rounded-full text-xs font-medium transition-colors ${
        isLow
          ? 'border-yellow-500/40 bg-yellow-500/10 text-yellow-300 hover:bg-yellow-500/15'
          : 'border-[#D4AF37]/40 bg-[#D4AF37]/10 text-[#D4AF37] hover:bg-[#D4AF37]/15'
      } ${className}`}
      title={`${credits} streaming credits — tap to buy more`}
      data-testid="credit-balance-badge"
    >
      <Coins size={13} />
      <span className="font-['Bebas_Neue'] text-sm tracking-wide" data-testid="credit-balance-count">
        {loading ? '…' : credits}
      </span>
    </button>
  );
};

export default CreditBalanceBadge;
